import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_13: FaireProductEntity = {
  token: "legacy_prod_abbott-13",
  type: "product",
  name: "Black LED Pillar Candle 4x8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5c5c0d00c3910741f1a655a68645823933b4ba4aa5307e44b2d5d53e25f75748.jpeg",
  priceDollars: 12,
  msrpDollars: 24,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
